import { Card, CardContent, Typography, Box } from '@mui/material';
import { Assignment as AssignmentIcon } from '@mui/icons-material';
import { useNavigationStore } from '../router/navigation-store';
import { formatPhone, formatAddress } from '@core/utils/formatting';

export function ProductInfoCard() {
  const urlParams = useNavigationStore((state) => state.urlParams);
  const resolvedItemCode = useNavigationStore((state) => state.resolvedItemCode);

  if (!urlParams) return null;

  // Use resolved item_code if available, fall back to URL param
  const displayItemCode = resolvedItemCode || urlParams.item_code;

  return (
    <Card sx={{ mb: 2 }}>
      <CardContent sx={{ px: 4, py: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
          <AssignmentIcon sx={{ fontSize: 18, color: 'primary.main' }} />
          <Typography
            variant="h5"
            component="h2"
            sx={{ fontWeight: 600, color: 'text.primary' }}
          >
            Thông tin sự vụ
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
          <InfoRow label="Mã đơn" value={urlParams.incident_id} />
          <InfoRow label="Mã sản phẩm" value={displayItemCode} />
          {urlParams.item_name && <InfoRow label="Tên sản phẩm" value={urlParams.item_name} />}
          <InfoRow label="Serial" value={urlParams.serial_no} />
          <InfoRow label="Khách hàng" value={urlParams.customer_name} />
          <InfoRow label="Địa chỉ" value={formatAddress(urlParams.customer_address ?? '')} />
          <InfoRow label="SĐT khách hàng" value={formatPhone(urlParams.customer_phone ?? '')} />
        </Box>
      </CardContent>
    </Card>
  );
}

function InfoRow({ label, value }: { label: string; value?: string }) {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 2 }}>
      <Typography
        variant="body2"
        sx={{ minWidth: 110, color: 'text.secondary', fontSize: '0.8125rem' }}
      >
        {label}:
      </Typography>
      <Typography
        variant="body2"
        sx={{
          fontWeight: 500,
          textAlign: 'right',
          flex: 1,
          color: 'text.primary',
          fontSize: '0.8125rem',
        }}
      >
        {value || '-'}
      </Typography>
    </Box>
  );
}
